import { useTranslation } from "react-i18next";

interface EnabledBadgeProps {
  enabled: boolean;
}

/**
 * Active/Inactive chip for scheduled email reports.
 * Uses the canonical `.score-badge.{success,neutral}` palette from
 * `statsNew.css` so all chips across Stats share one visual language.
 */
const EnabledBadge = ({ enabled }: EnabledBadgeProps) => {
  const { t } = useTranslation();
  return (
    <span className={`score-badge ${enabled ? "success" : "neutral"} font-normal`}>
      {enabled
        ? t("pages.statistics.reports.fields.enabled")
        : t("pages.statistics.reports.fields.disabled")}
    </span>
  );
};

export default EnabledBadge;
